module.exports = __webpack_public_path__ + "img/customer@2x.863512c8.png";